import React from 'react';

import {
  IconWrapper,
  StatCard,
  StatLabel,
  StatValue,
  StatsCardsContainer,
} from './StatsCards.styles';

const StatsCards = ({ stats }) => {
  return (
    <StatsCardsContainer>
      <StatCard $color="#2B7FFF">
        <IconWrapper $bgColor="#2B7FFF"></IconWrapper>
        <div>
          <StatLabel>TOTAL LEADS</StatLabel>
          <StatValue>{stats.totalLeads.toLocaleString()}</StatValue>
        </div>
      </StatCard>

      <StatCard $color="#15C7A7">
        <IconWrapper $bgColor="#15C7A7"></IconWrapper>
        <div>
          <StatLabel>TOTAL CONVERTED</StatLabel>
          <StatValue>{stats.totalConverted.toLocaleString()}</StatValue>
        </div>
      </StatCard>

      <StatCard $color="#FF6900">
        <IconWrapper $bgColor="#FF6900"></IconWrapper>
        <div>
          <StatLabel>TOTAL VALUE</StatLabel>
          <StatValue>{stats.totalValue}</StatValue>
        </div>
      </StatCard>

      <StatCard $color="#8B5CF6">
        <IconWrapper $bgColor="#8B5CF6"></IconWrapper>
        <div>
          <StatLabel>CONVERSION RATE</StatLabel>
          <StatValue>{stats.conversionRate}</StatValue>
        </div>
      </StatCard>
    </StatsCardsContainer>
  );
};

export default StatsCards;
